import { LangProvider } from './i18n';
import { AuthProvider } from './contexts/AuthContext';
import { ConsentProvider } from './contexts/ConsentContext';
import { AnalyticsProvider } from './contexts/AnalyticsContext';
import { LeadModalProvider } from './contexts/LeadModalContext';
import { ToastProvider } from './components';
import AppRoutes from './router';

export default function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <ConsentProvider>
          <AnalyticsProvider>
            <ToastProvider>
              <LeadModalProvider>
                <AppRoutes />
              </LeadModalProvider>
            </ToastProvider>
          </AnalyticsProvider>
        </ConsentProvider>
      </AuthProvider>
    </LangProvider>
  );
}
